import { Api } from "@/api/Api";
import type { LayerCreateUnion } from "@/layers";
import type { CartographicMapInput } from "@mm/metx-workbench.meteomatics.com";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createLayer = createAsyncThunk(
  "api/layer/create",
  async (payload: { mapId: CartographicMapInput["id"]; data: LayerCreateUnion; profileId: number }, _thunkAPI) => {
    return await Api.layer
      .v2CreateMapLayer({
        mapId: payload.mapId,
        profileId: payload.profileId,
        layerIn: payload.data,
      })
      .then((layer) => {
        return layer;
      });
  },
);

export const createMultipleLayers = createAsyncThunk(
  "api/layer/create-multi",
  async (
    payload: { mapId: CartographicMapInput["id"]; data: Array<LayerCreateUnion>; profileId: number },
    _thunkAPI,
  ) => {
    return await Api.layer
      .v2CreateMapLayers({
        mapId: payload.mapId,
        profileId: payload.profileId,
        v2CreateMapLayersRequestInner: payload.data,
      })
      .then((layers) => {
        return layers;
      });
  },
);
